export const newAudienceTableHeader = [
  { title: 'Name', key: 'name' },
  { title: 'Contact Type', key: 'contactType_Display' },
  { title: 'Mobile', key: 'mobile' },
  { title: 'Email', key: 'email' },
  // { title: 'Term', key: 'selectedTerm_Display' },
  { title: 'Field of Interest', key: 'fieldOfInterest_Display' },
  { title: 'Program', key: 'applicationStart_Display' },
  { title: 'Nationality', key: 'nationality_Display' },
  { title: 'Type', key: 'type' },
  { title: 'Status', key: 'statusText', flag: 'status' },
  { title: 'Notes Count', key: 'noteCount' },
  { title: 'Email Count', key: 'emailCount' },
  { title: 'Source Of Connection', key: 'sourceOfConnection' },
  { title: 'Grade', key: 'grade_Display' },
  { title: 'High School GPA', key: 'highSchoolGPA' },
  { title: 'Curriculum', key: 'curriculum_Display' },
  {
    title: 'Last Email Received On',
    key: 'lastEmailReceivedOnDisplay',
  },
  { title: 'Priority', key: 'priority_Display' },
  { title: 'Country', key: 'country_Display' },
  { title: 'Job Title', key: 'jobTitle' },
  { title: 'User Assigned', key: 'userAssigned' },
  { title: 'School', key: 'schoolName' },
  { title: 'Created On', key: 'createdOnDisplay' },
];
